import { UserModel } from "../../user/models/UserModel"
import { BillingComissionModel } from "../../billing/models/BillingComissionModel"

export class SellerAccountStatementModel {
    description:string = ''
    amount: number = 0
    balance: number = 0
    date: Date|string = new Date()
    billingCommission: BillingComissionModel|null = null
    user: UserModel

    constructor(s?:Partial<SellerAccountStatementModel>) {
        Object.assign(this, s)

        this._parseBillingCommission()
        this._parseUser()
    }

    hasBillingCommission():boolean {
        return !!this.billingCommission
    }

    private _parseBillingCommission():void {
        if (!!this.billingCommission) {
            this.billingCommission = new BillingComissionModel(this.billingCommission)
        }
    }

    private _parseUser():void {
        this.user = new UserModel(this.user)
    }
}
